import { useState, useEffect } from 'react';

export function useSessionState<T>(key: string, initialValue: T): [T, (value: T | ((previousValue: T) => T)) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const savedValue = sessionStorage.getItem(key);
      if (savedValue !== null) {
        return JSON.parse(savedValue);
      }
    } catch (error) {
      console.error(`Failed to parse saved session state for key "${key}":`, error);
      sessionStorage.removeItem(key);
    }
    return initialValue;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Failed to save session state for key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
}
